import React from 'react';
import { useParams } from 'react-router-dom';
import AdminCrudPage from './AdminCrudPage';
import AdminProfileSettings from './AdminProfileSettings';
import AdminWebsiteSections from './AdminWebsiteSections';
import AdminEmployeeVerification from './AdminEmployeeVerification';

const AdminModulePage = () => {
  const { resourceKey } = useParams();

  if (resourceKey === 'profile-settings') {
    return <AdminProfileSettings />;
  }

  if (resourceKey === 'website-sections') {
    return <AdminWebsiteSections />;
  }

  if (resourceKey === 'employee-verification') {
    return <AdminEmployeeVerification />;
  }

  return <AdminCrudPage />;
};

export default AdminModulePage;
